// The control-type union and the accordion allow-list, split out of dynamic.interface.ts (WI 34964).
// dynamic.interface.ts re-exports both, so existing imports are unchanged.

export type DynamicModelType =
  | 'input'
  | 'text'
  | 'textarea'
  | 'date'
  | 'file'
  | 'number'
  | 'phone'
  | 'checkbox'
  | 'email'
  | 'html-text'
  | 'label'
  | 'last-modified'
  | 'button'
  | 'numerictextbox'
  | 'addressautocomplete'
  | 'typeahead'
  | 'typeahead-autocomplete'
  | 'typeahead-category'
  | 'typeahead-company'
  | 'typeahead-customers'
  | 'typeahead-employee'
  | 'typeahead-job'
  | 'typeahead-facilities'
  | 'typeahead-icons'
  | 'typeahead-serial-number'
  | 'typeahead-sublocation'
  | 'typeahead-material'
  | 'typeahead-item'
  | 'typeahead-manufacturer'
  | 'typeahead-sales-order'
  | 'typeahead-office'
  | 'typeahead-plant'
  | 'typeahead-vendor'
  | 'typeahead-gl-account'
  | 'typeahead-purchase-order'
  | 'target'
  | 'target-loading'
  | 'target-clear'
  | 'accordion'
  | 'buttongroup'
  | 'chart'
  | 'circle'
  | 'image'
  | 'radio'
  | 'safetyatrisk'
  | 'signature'
  | 'coaching'
  | 'ai-coaching'
  | 'review'
  | 'copyLinkButton'
  | 'comment'
  | 'redacted'
  | 'dataLabels'
  | 'time';
// the dynamic builder allows for extra custom types to control custom property behavior
export type DynamicPropertyModelType =
  DynamicModelType | 'typeahead-all' | 'all';
// list of controls that are allowed to be inside accordions:
export const dynamicAccordionControls: Array<DynamicModelType> = [
  'input',
  'textarea',
  'date',
  'file',
  'checkbox',
  'buttongroup',
  'typeahead',
  'typeahead-autocomplete',
  'typeahead-company',
  'typeahead-customers',
  'typeahead-employee',
  'typeahead-facilities',
  'typeahead-job',
  'typeahead-icons',
  'typeahead-serial-number',
  'typeahead-sublocation',
  'typeahead-item',
  'typeahead-manufacturer',
  'typeahead-sales-order',
  'typeahead-plant',
  'typeahead-vendor',
  'typeahead-gl-account',
  'typeahead-purchase-order',
];
